import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Icon } from '../components/Icon.jsx';

const ToastCtx = createContext(() => {});

/**
 * Bestätigungen statt Rückfragen: jede Buchung meldet sich kurz, optional mit «Rückgängig».
 * show({ text, undo?: () => void, error?: boolean, long?: boolean })
 * Mit `withHinweis(text, hinweis)` werden Server-Hinweise (z. B. fehlender Ordner) angehängt.
 */
export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);

  const show = useCallback((t) => {
    clearTimeout(timer.current);
    setToast({ ...t, key: Date.now() });
    timer.current = setTimeout(() => setToast(null), t.error || t.long ? 7000 : 4500);
  }, []);

  useEffect(() => () => clearTimeout(timer.current), []);

  return (
    <ToastCtx.Provider value={show}>
      {children}
      {toast && (
        <div className={`toast${toast.error ? ' err' : ''}`} role={toast.error ? 'alert' : 'status'} key={toast.key}>
          <span className="tick"><Icon name={toast.error ? 'x' : 'check'} size={14} stroke={3} /></span>
          <span style={{ flex: 1, minWidth: 0 }}>{toast.text}</span>
          {toast.undo && (
            <button
              className="btn ghost"
              style={{ minHeight: 48, padding: '0 12px', fontSize: 13 }}
              onClick={() => { const u = toast.undo; setToast(null); u(); }}
            >
              Rückgängig
            </button>
          )}
        </div>
      )}
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);

/** Toast-Inhalt mit optionalem Hinweis der API (bleibt länger stehen). */
export const withHinweis = (text, hinweis) => (hinweis ? { text: `${text} · ${hinweis}`, long: true } : { text });
